import React, { PureComponent } from 'react'
import { pure } from 'recompose'
import { get, noop, omit } from 'lodash'
import Chip from 'material-ui/Chip'
import FlatButton from 'material-ui/FlatButton'
import ContentRemove from 'material-ui/svg-icons/content/remove'
import { Row, Col } from 'pui-react-grids'
import { Card, CardMedia, CardText } from 'material-ui/Card'
import Dotdotdot from '../MagikDotDotDot'
import {
  getImmaginiOfUser,
  getObjectCondition,
  callPreventDefault,
} from '../../utils'
import { themeColors } from '../../styles/theme'
import FixedImg from '../FixedImg'
import MediaQuery from 'react-responsive'
import breakpoints from '../../styles/breakpoints'

const styles = {
  cardContainer: {
    opacity: 1,
    backgroundColor: '#fff',
    marginTop: 15,
    cursor: 'pointer',
  },
  cardContainerChoosed: {
    opacity: 1,
    backgroundColor: themeColors.lightBackground,
    marginTop: 15,
  },
  rmBtn: {
    width: 36,
    minWidth: 36,
  },
  tableExpanded: {
    fontSize: 12,
  },
  detailDescrizione: {
    fontWeight: 'bold',
    paddingTop: '5px',
    paddingRight: 20,
  },
  detailValore: {
    paddingTop: '5px',
    paddingLeft: '15px',
  },
  notes: {
    fontSize: 12,
  },
}

// Styles for desktop
const dStyles = {
  container: {
    display: 'flex',
  },
  rightContainer: {
    display: 'flex',
    height: 150,
    flex: 1,
  },
  infoContainer: {
    overflow: 'hidden',
    flex: 1,
    fontSize: 12,
    padding: 16,
  },
  itemTitle: {
    overflow: 'hidden',
    fontSize: 15,
  },
  actionContainer: {
    padding: 10,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
  },
}

// Styles for mobile
const mStyles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
  itemContainer: {
    display: 'flex',
    padding: 10,
  },
  itemTitle: {
    flex: 1,
    overflow: 'hidden',
    fontSize: 15,
  },
  infoContainer: {
    padding: 16,
    fontSize: 12,
  },
  actionContainer: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  actionContainerChoosed: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
}

const MoneyChip = pure(({ money, color }) => (
  <Chip
    style={{ height: 32, border: `1px solid ${color}` }}
    backgroundColor={'rgba(0,0,0,0)'}
    labelColor={color}>
    € {money}
  </Chip>
))

const emptyArray = []
const TableExpanded = pure(({ item, showImages }) => (
  <CardText>
    <table style={styles.tableExpanded}>
      <tbody>
        {(item.attributi || emptyArray).map(attributo => (
          <tr key={attributo.descrizione}>
            <td style={styles.detailDescrizione}>{attributo.descrizione}</td>
            <td style={styles.detailValore}>{attributo.valore}</td>
          </tr>
        ))}
        {get(item, 'posseduto_da.length', 0) > 0 && (
          <tr>
            <td style={styles.detailDescrizione}>
              {item.categoria.id === 50 ? 'Condizioni Disco' : 'Condizioni'}
            </td>
            <td style={styles.detailValore}>
              {getObjectCondition(
                item.categoria.id,
                get(item, 'posseduto_da[0].condizioni', 0)
              )}
            </td>
          </tr>
        )}
        {item.categoria.id === 50 &&
          get(item, 'posseduto_da.length', 0) > 0 && (
            <tr>
              <td style={styles.detailDescrizione}>Condizioni Copertina</td>
              <td style={styles.detailValore}>
                {getObjectCondition(
                  item.categoria.id,
                  get(item, 'posseduto_da[0].condizioni2', 0)
                )}
              </td>
            </tr>
          )}
      </tbody>
    </table>
    <p style={styles.notes}>{get(item, 'posseduto_da[0].note', '')}</p>
    {showImages &&
      item.altre_immagini &&
      get(item, 'posseduto_da[0].user.id') && (
        <Row>
          {getImmaginiOfUser(
            item.altre_immagini,
            get(item, 'posseduto_da[0].user.id')
          ).map(immagine => (
            <Col md={6} sm={8} xs={8} key={immagine.percorso}>
              <div style={{ margin: 5 }}>
                <a
                  href={immagine.percorso}
                  rel="noopener noreferrer"
                  target="_blank">
                  <FixedImg
                    src={immagine.percorso}
                    resolution="small"
                    height={100}
                  />
                </a>
              </div>
            </Col>
          ))}
        </Row>
      )}
  </CardText>
))

const CardItemSwap = pure(
  ({
    item,
    editable,
    choosed,
    expanded,
    toggleItem,
    moneyChip,
    toggleExpanded,
    showImages,
    /* Style props */
    color,
    choosedColor,
    cardContainerStyle,
    cardContainerChoosedStyle,
  }) => (
    <Card
      onClick={choosed || !editable ? noop : toggleItem}
      containerStyle={choosed ? cardContainerChoosedStyle : cardContainerStyle}>
      <MediaQuery minWidth={breakpoints.xs}>
        {matches => (
          <div>
            {matches ? (
              <div>
                <div style={dStyles.container}>
                  {/*  Desktop */}
                  <CardMedia>
                    <FixedImg src={item.immagine} height={150} />
                  </CardMedia>

                  <div style={dStyles.rightContainer}>
                    <div style={dStyles.infoContainer}>
                      <div style={dStyles.itemTitle}>{item.titolo}</div>
                      <Dotdotdot clamp={2}>
                        {get(item, 'attributi[0].valore', '')}
                      </Dotdotdot>
                      <Dotdotdot clamp={2}>
                        {get(item, 'attributi[1].valore', '')}
                      </Dotdotdot>
                    </div>
                    <div style={dStyles.actionContainer}>
                      {moneyChip && (
                        <MoneyChip
                          color={choosed ? choosedColor : color}
                          money={get(item, 'posseduto_da[0].valore')}
                        />
                      )}
                      {choosed &&
                        editable && (
                          <FlatButton
                            onClick={toggleItem}
                            style={styles.rmBtn}
                            icon={<ContentRemove />}
                            backgroundColor={choosedColor}
                          />
                        )}
                      <FlatButton
                        label="Dettagli"
                        onClick={callPreventDefault(toggleExpanded)}
                      />
                    </div>
                  </div>
                </div>
                {expanded && (
                  <TableExpanded item={item} showImages={showImages} />
                )}
              </div>
            ) : (
              <div style={mStyles.container}>
                {/*  Mobile */}
                <div style={mStyles.itemContainer}>
                  <div style={mStyles.itemTitle}>{item.titolo}</div>
                  {moneyChip && (
                    <MoneyChip
                      color={choosed ? choosedColor : color}
                      money={get(item, 'posseduto_da[0].valore')}
                    />
                  )}
                </div>

                <CardMedia>
                  <FixedImg src={item.immagine} height={120} />
                </CardMedia>

                <div style={mStyles.infoContainer}>
                  <Dotdotdot clamp={1}>
                    {get(item, 'attributi[0].valore', '')}
                  </Dotdotdot>
                  <Dotdotdot clamp={1}>
                    {get(item, 'attributi[1].valore', '')}
                  </Dotdotdot>
                </div>

                {expanded && (
                  <TableExpanded item={item} showImages={showImages} />
                )}

                <div
                  style={
                    choosed
                      ? mStyles.actionContainerChoosed
                      : mStyles.actionContainer
                  }>
                  {choosed &&
                    editable && (
                      <FlatButton
                        onClick={toggleItem}
                        style={styles.rmBtn}
                        icon={<ContentRemove />}
                        backgroundColor={choosedColor}
                      />
                    )}
                  <FlatButton
                    style={{ justifySelf: 'flex-end' }}
                    label="Dettagli"
                    onClick={callPreventDefault(toggleExpanded)}
                  />
                </div>
              </div>
            )}
          </div>
        )}
      </MediaQuery>
    </Card>
  )
)

export default class CardItemSwapExpandable extends PureComponent {
  state = {
    expanded: false,
  }

  toggleExpanded = () => {
    this.setState(state => ({ expanded: !state.expanded }))
  }

  toggleItem = () => {
    if (this.props.choosed) {
      this.props.removeItem(this.props.item)
    } else {
      this.props.addItem(this.props.item)
    }
  }

  render() {
    const passProps = omit(this.props, ['addItem', 'removeItem'])

    return (
      <CardItemSwap
        {...passProps}
        toggleItem={this.toggleItem}
        expanded={this.state.expanded}
        toggleExpanded={this.toggleExpanded}
      />
    )
  }
}

CardItemSwapExpandable.defaultProps = {
  color: themeColors.secondary,
  choosedColor: themeColors.energized,
  editable: true,
  moneyChip: true,
  showImages: false,
  cardContainerStyle: styles.cardContainer,
  cardContainerChoosedStyle: styles.cardContainerChoosed,
}



// WEBPACK FOOTER //
// ./src/common/Swap/CardItemSwap.js